module.exports = __webpack_public_path__ + "img/facebook_blue.91ce3eac.svg";